import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getSeventhFlow = asyncThunkWrapper({ 
  model: 'seventhFlow', 
  action: 'getSeventhFlow', 
  func: async () => {
    const attributes = ['id', 'phone', 'email', 'prompt', 'updated_at'];
    const params = { attributes };
    const response = await axios.get(`/seventh_flow`, { params });

    return response.data;
  } 
});
export const createSeventhFlow = asyncThunkWrapper({ 
  model: 'seventhFlow', 
  action: 'createSeventhFlow', 
  func: async (seventh_flow) => {
    const attributes = ['id', 'phone', 'email', 'prompt', 'updated_at'];
    const response = await axios.post(`/seventh_flow`, { seventh_flow, attributes });

    return response.data;
  } 
});
export const updateSeventhFlow = asyncThunkWrapper({ 
  model: 'seventhFlow', 
  action: 'updateSeventhFlow', 
  func: async (seventh_flow) => {
    const response = await axios.patch(`/seventh_flow`, { seventh_flow });

    return { status: response.status, seventh_flow };
  } 
});
export const deleteSeventhFlow = asyncThunkWrapper({ 
  model: 'seventhFlow', 
  action: 'deleteSeventhFlow', 
  func: async () => {
    const response = await axios.delete(`/seventh_flow`);

    return { status: response.status };
  } 
});
export const clearLocalActiveSeventhFlow = createAction('seventhFlow/clearLocalActiveSeventhFlow');